import { isMatchAbbreviation } from "../Types";
import { isNullOrEmpty } from "../../../../../../../../../Common/TypingUtils";

import { FiasHouseTypes } from "./HouseTypes";

export function getHouseTypeLongName(houseType: string | number | undefined): string | undefined {
    const stringFlatType = houseType?.toString();
    const roomName = FiasHouseTypes.find(abbreviation => isMatchAbbreviation(abbreviation, stringFlatType))?.long;
    if (isNullOrEmpty(roomName)) {
        return undefined;
    }
    return roomName;
}

export function getHouseTypeShortName(houseType: string | number | undefined): string | undefined {
    const stringFlatType = houseType?.toString();
    const roomName = FiasHouseTypes.find(abbreviation => isMatchAbbreviation(abbreviation, stringFlatType))?.short;
    if (isNullOrEmpty(roomName)) {
        return undefined;
    }
    return roomName;
}

export function getHouseTypeObjectID(houseType: string | number | undefined): string | undefined {
    const stringFlatType = houseType?.toString();
    const roomName = FiasHouseTypes.find(abbreviation => isMatchAbbreviation(abbreviation, stringFlatType))?.objectID;
    if (isNullOrEmpty(roomName)) {
        return undefined;
    }
    return roomName;
}
